var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #0071f2;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47007",
    "data-name": "Rectangle 47007",
    className: "cls-1",
    width: 12,
    height: 12,
    transform: "translate(732 714)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1145",
    "data-name": "Mask Group 1145",
    className: "cls-2",
    transform: "translate(-732 -714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-task",
    className: "cls-3",
    d: "M12.15,2.05H9.64a1.789,1.789,0,0,0-3.379,0H3.75a1.2,1.2,0,0,0-1.2,1.2v8.4a1.2,1.2,0,0,0,1.2,1.2h8.4a1.2,1.2,0,0,0,1.2-1.2V3.25A1.2,1.2,0,0,0,12.15,2.05Zm-4.2,0a.6.6,0,1,1-.6.6.6.6,0,0,1,.6-.6Zm-1.8,8.4H4.95V9.25L8.638,5.562l1.2,1.2Zm4.712-4.712-.6.6-1.2-1.2.6-.6a.3.3,0,0,1,.424,0l.776.776a.3.3,0,0,1,0,.424ZM12.15,11.65H3.75V3.25h8.4Z",
    transform: "translate(730.05 713.15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.930c719856ee19201d5dab449d1ad11b.svg";
export { ForwardRef as ReactComponent };